/* ==========================================================================
   AASGARA wishlist
   Favoriler tarayicida (localStorage) tutulur — uye girisi gerekmez.
   Tek bir kaynak: butun kalp ikonlari bu dosyadan yonetilir.
   Disari acilan API: window.AasgaraWishlist.sync() / .items() / .has(handle)
   ========================================================================== */
(function () {
  'use strict';

  var STORAGE_KEY = 'wishlist';
  var COUNT_KEY = 'user_wishlist_cnt';

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(raw) ? raw : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      localStorage.setItem(COUNT_KEY, String(items.length));
    } catch (e) {
      /* private mode: sessizce gec */
    }
    updateCounters(items.length);
  }

  function updateCounters(count) {
    var nodes = document.querySelectorAll('.wishlist-counter');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = String(count);
  }

  /* Sayfadaki butun kalpleri kayitli listeye gore isaretle.
     AJAX ile yeni urun kartlari geldiginde de cagrilir. */
  function sync() {
    var items = read();
    var hearts = document.querySelectorAll('.wishlist[data-handle]');
    for (var i = 0; i < hearts.length; i++) {
      var el = hearts[i];
      var active = items.indexOf(el.getAttribute('data-handle')) !== -1;
      el.classList.toggle('active-wishlist', active);
      el.classList.toggle('wishlist-custom-action', !active);
      el.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (!el.getAttribute('aria-label')) {
        el.setAttribute('aria-label', el.getAttribute('data-handle'));
      }
    }
    updateCounters(items.length);
  }

  function toggle(handle) {
    var items = read();
    var index = items.indexOf(handle);
    if (index === -1) {
      items.push(handle);
    } else {
      items.splice(index, 1);
    }
    write(items);
    sync();
    document.dispatchEvent(
      new CustomEvent('wishlist:changed', {
        detail: { handle: handle, added: index === -1, count: items.length }
      })
    );
    return index === -1;
  }

  document.addEventListener('click', function (event) {
    var el = event.target.closest ? event.target.closest('.wishlist[data-handle]') : null;
    if (!el) return;
    event.preventDefault();
    toggle(el.getAttribute('data-handle'));
  });

  /* Koleksiyon filtresi grid'i yeniden cizince kalpler sifirlanmasin */
  function observe() {
    var target = document.getElementById('ProductGridContainer') || document.querySelector('.product-wrap');
    if (!target || typeof MutationObserver === 'undefined') return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        sync();
      });
    }).observe(target, { childList: true, subtree: true });
  }

  function init() {
    sync();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.AasgaraWishlist = { sync: sync, toggle: toggle, items: read, has: function (h) { return read().indexOf(h) !== -1; } };
})();
